export default {"src":"/_next/static/media/credit.db3bff87.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};